import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-vw-100 min-vh-100 d-flex align-items-center justify-content-center flex-column">
      <h1 className="headline text-warning"> 404</h1>
      <h3>
        <i className="fas fa-exclamation-triangle text-warning" /> Oops! Page
        not found.
      </h3>
      <Link to="/" className="btn btn-info">
        <i className="fa fa-arrow-left mx-1" aria-hidden="true"></i>
        Home
      </Link>
    </div>
  );
}
